import React from "react";

const ToggleSwitch = ({ 
  leftLabel = "Option 1", 
  rightLabel = "Option 2", 
  value, 
  onChange 
}) => {
  return (
    <div className="flex items-center space-x-2">
      {/* Label kiri */}
      <span
        className={`cursor-pointer text-sm font-medium ${
          value === "left" ? "text-green-600" : "text-gray-500"
        }`}
        onClick={() => onChange("left")}
      >
        {leftLabel}
      </span>

      {/* Toggle */}
      <div
        className="relative flex items-center bg-gray-300 rounded-full cursor-pointer w-14 h-7"
        onClick={() => onChange(value === "left" ? "right" : "left")}
      >
        <div
          className={`absolute top-1 left-1 w-5 h-5 rounded-full bg-white shadow-md transform transition-transform duration-300 ${
            value === "right" ? "translate-x-7" : "translate-x-0"
          }`}
        />
      </div>

      {/* Label kanan */}
      <span
        className={`cursor-pointer text-sm font-medium ${
          value === "right" ? "text-green-600" : "text-gray-500"
        }`}
        onClick={() => onChange("right")}
      >
        {rightLabel}
      </span>
    </div>
  );
};

export default ToggleSwitch;
